import { useGetInstitutions } from '@vindr/services/actions/institution.action';
import { ColumnType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';

const InstitutionColumn = ({
  title = 'Institution',
  dataIndex = 'institution_id',
  width = 80,
  key = 'institution_id',
  sorter,
  ...props
}: ColumnType<any> = {}) => {
  const { t } = useTranslation('Vindoc');
  const { data: Institution } = useGetInstitutions({ limit: 100, offset: 0 });

  return {
    title: t(title),
    dataIndex,
    key,
    width,
    sorter,
    render: (text) => {
      if (!text || !Institution?.data?.length) return '';
      const getInstitutionNameById = (id) => Institution?.data.find((item) => item.id === id)?.name;

      if (Array.isArray(text)) {
        return text.map(getInstitutionNameById).filter(Boolean).join(', ');
      }

      return getInstitutionNameById(text) || '';
    },
    ...props,
  };
};

export default InstitutionColumn;
